import React from 'react'

export const SearchEnum = {
    opr :
    { 
        Or: 'or',    // =
        Equal: 'eq',    // =
        Like: 'like',  // like
        Greater:'greater', // >
        GreaterOrEqual:'greaterOrEqual', // >=
        Less: 'less',      //  <
        LessOrEqual: 'lessOrEqual',      // <=
        In: 'in' ,                     // in
        Between:'between'              // between
    },
    itemType:
    {
        default:'default',
        projectFilter:'projectFilter',
        commonSearch:'commonSearch',
        text:'text',
        numberRange:'numberRange',
        dateRange:'dateRange',
        multCheck:'multCheck'
    }
}

export interface AppFilter{
    keyName?:string
    lable?:string
    field?:string
    min?:string
    max?:string
    opr?:string
    value?:string
    list?:string[]
    searchItemType?:string
    describe?:string   // 中文描述
    allowClear?:boolean
}

export interface AppTableSearchProps {
    showMore?: boolean
    defaultData?:any
    onSearch?:(filterList?:AppFilter[],data?:any)=>void
}


interface AppTableSearchContext {
    data?: any
    filterList?:AppFilter[]
    existAdvanced?:boolean
    onItemChange? : (filter?:AppFilter) => void
    onItemSearch?:(filter?:AppFilter) =>void
    onCloseItem?:(filter?:AppFilter) =>void
    showMore?: boolean
	onSearch?: () => void
	handleClickMore?: () => void
	clearSearch?: () => void
}

export const AppTableSearchContext = React.createContext<AppTableSearchContext>({} as AppTableSearchContext)

export const AppTableSearchServer = {
    hanldItemChange : (filterList?:AppFilter[],updateFilter?:AppFilter) =>{
        let arrFilter:AppFilter[] = [] ;
        let isNew = true;
        updateFilter = {...updateFilter,describe:getFilterDescribe(updateFilter)}
        filterList.map((filter:AppFilter)=>{
            if(filter.keyName === updateFilter.keyName){
                isNew = false;
                arrFilter.push({...updateFilter});
            }else{
                arrFilter.push({...filter});
            }
        })
        if(isNew) arrFilter.push({...updateFilter});
        return arrFilter;
    },

    handleData :(filter?:AppFilter,data?:any)=>{
        let key = filter.keyName;
        switch (filter.searchItemType){
            case SearchEnum.itemType.multCheck:
            return {...data,[key]:filter.list};
            case SearchEnum.itemType.dateRange:
            case SearchEnum.itemType.numberRange:
            return {...data,[`${key}_min`]:filter.min,[`${key}_max`]:filter.max};
            default:
            return {...data,[key]:filter.value}
        }
    },

    getDataByFilterList : (filterList?:AppFilter[]) =>{
        let newData:any = {};
        if(filterList.length > 0 ){
            filterList.map((filter:AppFilter)=>{
                newData = AppTableSearchServer.handleData(filter,newData)
            })
        }
        return newData;
    },

    getQueryFilterList:(filterList?:AppFilter[])=>{
        let arrFilter:AppFilter[] = [] ;
        filterList.map((filter:AppFilter)=>{
            if( filterEffective(filter)){
                arrFilter.push({...filter})
            }
        })
        return arrFilter;
    },

    clearSearch : (filterList?:AppFilter[],data?:any)=>{
        let arrFilter = filterList.filter(e => !e.allowClear)
        let newData = AppTableSearchServer.getDataByFilterList(arrFilter);
        return {arrFilter,newData};
    }
}

const valueIsNull = (value?:string)=> {
    if(value && value !== undefined && value !== null && value !== '') return false;
    return true;
}

const filterEffective = (filter?:AppFilter) =>{
    let key = filter.keyName;
        switch (filter.searchItemType){
            case SearchEnum.itemType.multCheck:
            return (Array.isArray(filter.list) && filter.list.length > 0);
            case SearchEnum.itemType.dateRange:
            case SearchEnum.itemType.numberRange:
            return (!valueIsNull(filter.min)) || (!valueIsNull(filter.max));
            default:
            return !valueIsNull(filter.value)
        }
}

const getFilterDescribe = (filter:AppFilter) =>{
    let {value,list,min,max}  = filter
    switch (filter.searchItemType)
    {
        case SearchEnum.itemType.dateRange,SearchEnum.itemType.numberRange:
            if(min !=='' && max !== ''){
                return `${min}-${max}`
            }else if(min !==''){
                return `大于等于：${min}`
            }else if (max !== ''){
                return `小于等于 ${max}`
            }
        case SearchEnum.itemType.multCheck:
            if(Array.isArray(list) && list.length > 0){
                return `${list.join('、')}`
            }
        case SearchEnum.itemType.text:
            if(value !== ''){
                return `${value}`
            }
    }

    return '';
}




// WEBPACK FOOTER //
// ./src/qcc/AppTableSearch/AppTableSearchServer.tsx